import { combineReducers } from 'redux';
import EscolasReducer from './modules/EscolasReducer';
import AgendaAssessoresPedagogicosReducer from './modules/AgendaAssessoresPedagogicosReducer';
import AssessoresReducer from './modules/AssessoresReducer';
import ContratosReducer from './modules/ContratosReducer';
import ContratosEntePublicoReducer from './modules/ContratosEntePublicoReducer';
import ContratosEntePrivadoReducer from './modules/ContratosEntePrivadoReducer';
import CoordenadoresReducer from './modules/CoordenadoresReducer';
import EmpresasReducer from './modules/EmpresasReducer';
import LanguageReducer from './modules/LanguageReducer';
import LogradouroReducer from './modules/LogradouroReducer';
import notificationsReducer from './modules/NotificationsReducer';
import ModalReducer from './modules/ModalReducer';
import ProfessoresReducer from './modules/ProfessoresReducer';
import ProjetoReducer from './modules/ProjetoReducer';
import TooltipManagerReducer from './modules/TooltipManagerReducer';
import LeftSidebarReducer from 'components/LeftSidebar/LeftSidebarReducer';
import AllContratosReducer from './modules/AllContratos/AllContratosReducer';
import contratosDescentralizadosAssessoresReducer from './modules/ContratosFluxoDescentralizado/Assessores/AssessoresReducer';
import ContratosAssessoresReducer from './modules/ContratosAssessoresReducer';
import contratosDescentralizadosEntePublicoReducer from './modules/ContratosFluxoDescentralizado/EntePublico/EntePublicoReducer';
import NewContratosEntePrivadoReducer from './modules/ContratosFluxoDescentralizado/EntePrivado/EntePrivadoReducer';
import AuthReducer from 'services/Auth/AuthReducer';

const rootReducer = combineReducers({
  auth: AuthReducer,
  assessores: AssessoresReducer,
  contratos: ContratosReducer,
  contratosAssessores: ContratosAssessoresReducer,
  contratosEntePrivado: ContratosEntePrivadoReducer,
  contratosEntePublico: ContratosEntePublicoReducer,
  allContratos: AllContratosReducer,
  contratosDescentralizadosAssessores: contratosDescentralizadosAssessoresReducer,
  contratosDescentralizadosEntePublico: contratosDescentralizadosEntePublicoReducer,
  contratosDescentralizadosEntePrivado: NewContratosEntePrivadoReducer,
  coordenadores: CoordenadoresReducer,
  empresas: EmpresasReducer,
  languages: LanguageReducer,
  leftSidebar: LeftSidebarReducer,
  modals: ModalReducer,
  notifications: notificationsReducer,
  professores: ProfessoresReducer,
  projeto: ProjetoReducer,
  tooltipManager: TooltipManagerReducer,
  agendaAssessoresPedagogicos: AgendaAssessoresPedagogicosReducer,
  logradouro: LogradouroReducer,
  escolas: EscolasReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
